export enum Groups {
  optionGdpr = "Option_GDPR",
}
